import React from "react";
import { ErrorBoundary } from "../ui/ErrorBoundary";
import ViewAsCardUI from "./ViewAsCard/ViewAsCardUI";

import { useSlice } from "components/hooks/useSlice";
import { useRoles } from "components/hooks/useRoles";

// https://wikihub.berkeley.edu/display/SIS/CalCentral+View+As+Card
export function ViewAsCard() {
  const { isSuperuser, isViewer } = useSlice("myStatus");
  const isAdvisor = useRoles((roles) => roles.advisor);

  if (isViewer || isSuperuser || isAdvisor) {
    return (
      <ErrorBoundary title="View As">
        <ViewAsCardUI />
      </ErrorBoundary>
    );
  }

  return null;
}
